import NextCone from "./components/next-cone";
import CdnComponent from "./components/cdn-component";
import Iframe from "./components/iframe";
export default [NextCone, CdnComponent, Iframe];